export interface SlideDeck {
  status: SlidesStatus
  timeStamp: string
  slidesId: string
  percentageComplete: number
  brightTalkDataLocation: string
  brightTalkLocation: string
  dataLocation: string
  s3Location: string
  fileName: string
  numberOfSlides?: number
  error?: string
}

export enum SlidesStatus {
  VIRUS_SCANNING ='VirusScanning',
  CONVERTING = 'Converting',
  FAILED = 'Failed',
  COMPLETE = 'Complete'
}

export interface SlidesObject {
  slideDecks: SlideDeck[]
  activeDeck: string | null
  isUploading: boolean
  uploadProgress: number
  cancelToken: Record<string, any> | null
  processingProgress: number
  pendingSlidesId: null | string
  hasError: boolean
  error: null | string
  pendingFile: Record<string, any> | null
  setAsFeatureImage: boolean
  featureImageRequested: string | null
  selectedSlide: number | null
  selectedSlideStep: number
  apiVersion: string | null
  isProcessing: boolean
  showSlidesRemoveConfirmModal: boolean
}
